<!-- Primary Sidebar Navigation -->
<nav class="sidenav" aria-label="Main navigation">
  @if (this.viewStateService.isMobileView) {
  <form role="search" class="search-form" (ngSubmit)="$event.preventDefault()">
    <div class="search-wrap" #searchRoot>
      <div class="search-container">
        <input
          #searchInput
          placeholder="Gehe zu…"
          type="search"
          [id]="devspaceSearchId"
          [formControl]="searchCtrl"
          autocomplete="off"
          (input)="onSearchInput()"
          (keydown)="onSearchKeyDown($event)"
          [class.mention-open]="showMention"
        />

        <button type="submit" class="search-button" aria-label="Search">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      @if (showMention) {
      <section class="mention-panel">
        <app-mention-list
          class="devspace-mention-list"
          [searchTerm]="mentionSearchTerm"
          [visible]="showMention"
          [mode]="mentionMode"
          [users]="mentionUsers"
          [channels]="mentionChannels"
          (pick)="insertMention($event)"
          (userSelected)="openDmFromMention($event)"
          (channelSelected)="openChannelFromMention($event)"
        ></app-mention-list>
      </section>
      }
    </div>
  </form>
  }
  <!-- Brand / Workspace -->
  <header class="sidenav-brand" [class.hidden]="this.viewStateService.isMobileView">
    <div class="brand-link" aria-label="Devspace Logo">
      <img class="brand-logo" src="assets/icons/devspace-logo.svg" alt="Devspace Logo" />
      <h2 class="brand-name">Devspace</h2>
    </div>
    <button class="trigger-message-btn" (click)="openNewDM()">
      <svg
        class="message-trigger-icon"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_237_472"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="8"
          y="8"
          width="32"
          height="32"
        >
          <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_237_472)">
          <path
            d="M13 31.6998C12.45 31.6998 11.9792 31.504 11.5875 31.1123C11.1958 30.7206 11 30.2498 11 29.6998V15.6998C11 15.1498 11.1958 14.679 11.5875 14.2873C11.9792 13.8956 12.45 13.6998 13 13.6998H21.925L19.925 15.6998H13V29.6998H27V22.7498L29 20.7498V29.6998C29 30.2498 28.8042 30.7206 28.4125 31.1123C28.0208 31.504 27.55 31.6998 27 31.6998H13ZM24.175 14.2748L25.6 15.6748L19 22.2748V23.6998H20.4L27.025 17.0748L28.45 18.4748L21.825 25.0998C21.6417 25.2831 21.4292 25.429 21.1875 25.5373C20.9458 25.6456 20.6917 25.6998 20.425 25.6998H18C17.7167 25.6998 17.4792 25.604 17.2875 25.4123C17.0958 25.2206 17 24.9831 17 24.6998V22.2748C17 22.0081 17.05 21.754 17.15 21.5123C17.25 21.2706 17.3917 21.0581 17.575 20.8748L24.175 14.2748ZM28.45 18.4748L24.175 14.2748L26.675 11.7748C27.075 11.3748 27.5542 11.1748 28.1125 11.1748C28.6708 11.1748 29.1417 11.3748 29.525 11.7748L30.925 13.1998C31.3083 13.5831 31.5 14.0498 31.5 14.5998C31.5 15.1498 31.3083 15.6165 30.925 15.9998L28.45 18.4748Z"
            fill="black"
            stroke="black"
            stroke-width="0"
          />
        </g>
      </svg>
    </button>
  </header>

  <div class="channels-and-contacts devspace-elements-gap">
    <app-channel-list [channels]="channels" [search]="search" [meUid]="meUid"></app-channel-list>

    <app-dm-list [search]="search" [meUid]="meUid"> </app-dm-list>
  </div>
</nav>

<button
  class="mobile-edit-btn"
  mat-fab
  aria-label="edit-btn"
  (click)="openNewDM()"
  *ngIf="viewStateService.isMobileView"
>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_237_472"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_237_472)">
      <path
        d="M13 31.6998C12.45 31.6998 11.9792 31.504 11.5875 31.1123C11.1958 30.7206 11 30.2498 11 29.6998V15.6998C11 15.1498 11.1958 14.679 11.5875 14.2873C11.9792 13.8956 12.45 13.6998 13 13.6998H21.925L19.925 15.6998H13V29.6998H27V22.7498L29 20.7498V29.6998C29 30.2498 28.8042 30.7206 28.4125 31.1123C28.0208 31.504 27.55 31.6998 27 31.6998H13ZM24.175 14.2748L25.6 15.6748L19 22.2748V23.6998H20.4L27.025 17.0748L28.45 18.4748L21.825 25.0998C21.6417 25.2831 21.4292 25.429 21.1875 25.5373C20.9458 25.6456 20.6917 25.6998 20.425 25.6998H18C17.7167 25.6998 17.4792 25.604 17.2875 25.4123C17.0958 25.2206 17 24.9831 17 24.6998V22.2748C17 22.0081 17.05 21.754 17.15 21.5123C17.25 21.2706 17.3917 21.0581 17.575 20.8748L24.175 14.2748ZM28.45 18.4748L24.175 14.2748L26.675 11.7748C27.075 11.3748 27.5542 11.1748 28.1125 11.1748C28.6708 11.1748 29.1417 11.3748 29.525 11.7748L30.925 13.1998C31.3083 13.5831 31.5 14.0498 31.5 14.5998C31.5 15.1498 31.3083 15.6165 30.925 15.9998L28.45 18.4748Z"
        fill="white"
      />
    </g>
  </svg>
</button>
